import React from 'react';
import {
  FaKey,
  FaUsers,
  FaCoffee,
  FaDoorOpen,
  FaDesktop,
  FaDumbbell,
  FaSmile,
  FaMountain,
  FaUtensils,
  FaEnvelope,
  FaIdCard,
  FaChair,
  FaParking,
  FaPhone,
  FaChalkboardTeacher,
  FaBolt,
  FaBriefcase,
  FaWifi,
  FaMugHot,
  FaChargingStation
} from 'react-icons/fa';
import './Amenities.css';
import IconWrapper from './IconWrapper';

const Amenities: React.FC = () => {
  const amenities = [
    { id: 1, icon: FaKey, title: '24/7 Access' },
    { id: 2, icon: FaUsers, title: 'Business Community' },
    { id: 3, icon: FaCoffee, title: 'Coffee and Tea' },
    { id: 4, icon: FaDoorOpen, title: 'Conference Rooms' },
    { id: 5, icon: FaDesktop, title: 'Coworking Space' },
    { id: 6, icon: FaDumbbell, title: 'Fitness Center' },
    { id: 7, icon: FaSmile, title: 'Friendly Atmosphere' },
    { id: 8, icon: FaMountain, title: 'Great Views' },
    { id: 9, icon: FaUtensils, title: 'Community Kitchen' },
    { id: 10, icon: FaEnvelope, title: 'Mail Services' },
    { id: 11, icon: FaIdCard, title: 'Membership Access' },
    { id: 12, icon: FaChair, title: 'Outdoor Seating' },
    { id: 13, icon: FaParking, title: 'Parking Access' },
    { id: 14, icon: FaPhone, title: 'Phone Rooms' },
    { id: 15, icon: FaChalkboardTeacher, title: 'Training Room' },
    { id: 16, icon: FaBolt, title: 'Utilities' },
    { id: 17, icon: FaBriefcase, title: 'Private Office' },
    { id: 18, icon: FaWifi, title: 'High-Speed WiFi' },
    { id: 19, icon: FaMugHot, title: 'On-site Café' },
    { id: 20, icon: FaChargingStation, title: 'EV Charging Stations' }
  ];

  // Sort amenities alphabetically by title
  const sortedAmenities = [...amenities].sort((a, b) => a.title.localeCompare(b.title));

  return (
    <section id="amenities" className="amenities">
      <div className="container">
        <div className="section-header">
          <h2>Featured Amenities</h2>
        </div>

        <div className="amenities-grid">
          {sortedAmenities.map((amenity) => (
            <div key={amenity.id} className="amenity-item">
              <div className="amenity-icon">
                <IconWrapper icon={amenity.icon} />
              </div>
              <div className="amenity-title">{amenity.title}</div>
            </div>
          ))}
        </div>

        <p className="amenities-tagline">Everything you need for a productive and comfortable workspace</p>
      </div>
    </section>
  );
};

export default Amenities; 